import { Resources } from 'constants/resources';

import { useCallback } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify, useRecordContext, useUpdate } from 'react-admin';
import { Switch } from 'shared/mui/Switch';
import { TypographyWithBold } from 'shared/mui/Typography';
import { MerchantAccount } from 'types/embedded/merchantAccount';

type Props = {
  size?: 'small' | 'medium';
};

export function MerchantAccountsNameFieldActiveSwitch({ size = 'small' }: Props): JSX.Element {
  const translate = useTypedTranslate();

  const notify = useNotify();
  const record = useRecordContext<MerchantAccount>();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: ['merchant_accounts'] });
    notify(
      <TypographyWithBold
        text={translate('app.merchantAccounts.activityUpdatedSuccessfully', {
          name: record?.name || '',
        })}
      />,
      { type: 'success' },
    );
  };

  const [update] = useUpdate(
    Resources.GatewayRules,
    { id: record?.id, data: { active: !record?.active } },
    {
      onSuccess: onSuccess,
      onError: (error: any) => {
        notify(`${translate('app.common.error')}: ${(error as Error).message}`, { type: 'error' });
      },
    },
  );

  const toggleActiveGatewayRule = useCallback(() => {
    update();
  }, [record?.active, record]);

  return (
    <Switch
      checked={record?.active}
      onClick={toggleActiveGatewayRule}
      size={size}
      sx={{
        marginRight: '16px',
      }}
    />
  );
}
